import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["options", "valueAccessor", "renderNativeOption", "onChange", "value", "width", "placeholder", "noOptionsText", "dataTestId"];
import React, { useContext, useCallback } from 'react';
import { StencilContext } from "../../../context";
import { buildDataTestProps } from "../../../utils";
import { defaultProps, TEXT_COLOR, PLACEHOLDER_TEXT_COLOR } from "../constants";
import { getItemToString } from "../utils";
import Option from "./Option";
import Select from "./Select";
import { jsx as ___EmotionJSX } from "@emotion/core";
var NativeSelect = /*#__PURE__*/React.forwardRef(function (_ref, externalRef) {
  var options = _ref.options,
      valueAccessor = _ref.valueAccessor,
      renderNativeOption = _ref.renderNativeOption,
      onChange = _ref.onChange,
      value = _ref.value,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? defaultProps.width : _ref$width,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? defaultProps.placeholder : _ref$placeholder,
      _ref$noOptionsText = _ref.noOptionsText,
      noOptionsText = _ref$noOptionsText === void 0 ? defaultProps.noOptionsText : _ref$noOptionsText,
      dataTestId = _ref.dataTestId,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useContext = useContext(StencilContext),
      selectors = _useContext.selectors;

  var isPlaceholderSelected = !value;
  var itemToString = useCallback(function (item) {
    return getItemToString(item, {
      valueAccessor: valueAccessor
    });
  }, [valueAccessor]);

  var renderOption = function renderOption(option) {
    if (renderNativeOption) {
      return renderNativeOption(option);
    }

    return itemToString(option);
  };

  var hasNoOptions = options.length === 0;

  var handleChange = function handleChange(e) {
    var newValue = options.find(function (option) {
      return itemToString(option) === e.target.value;
    });
    !!onChange && onChange(newValue);
  };

  var dataTestProps = buildDataTestProps({
    dataTestComponent: 'StencilSelect',
    dataTestId: dataTestId
  });
  return ___EmotionJSX(Select, _extends({}, dataTestProps, {
    onChange: handleChange,
    width: width,
    placeholder: hasNoOptions ? noOptionsText : placeholder,
    ref: externalRef,
    "aria-disabled": hasNoOptions,
    style: isPlaceholderSelected ? {
      fontStyle: 'italic',
      color: selectors.color(PLACEHOLDER_TEXT_COLOR)
    } : {
      color: selectors.color(TEXT_COLOR)
    }
  }, props, {
    value: itemToString(value)
  }), options.map(function (option, index) {
    return ___EmotionJSX(Option, {
      key: index,
      value: itemToString(option)
    }, renderOption(option));
  }));
});
NativeSelect.displayName = 'NativeSelect';
export default NativeSelect;